import * as $ from 'jquery';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { StockRequestHistorySliderModelService } from './sot-request-history.component-slider-model.service';
import { SOTService } from '../../../../services/seed/sot/sot.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sot-request-history',
  templateUrl: './sot-request-history.component.html',
  styleUrls: ['./sot-request-history.component.scss']
})
export class SotRequestHistoryComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  displayedColumns: string[] = ['Rejection Date', 'Rejected By', 'Rejection Reason', 'Resolution Date', 'Resolved By', 'Resolution Reason'];
  sotRequestId: number;
  requestHistoryDS: any;
  sotRequestNumber: string;
  requestedBy: string;
  creationDate: any;
  approvedBy: string;
  approvalDate: any;
  isFromAccess = false;
  isToAccess = false;
  isrequestStatus = false;

  constructor(
    private stockRequestHistorySliderModelService: StockRequestHistorySliderModelService,
    private stockTransferService: SOTService,
    private loaderService: LoaderService,
  ) { }

  ngOnInit(): void {
    this.sotRequestId = this.stockRequestHistorySliderModelService.sotRequestId;
    this.getRequestHistoryDetails();
  }

  setHistoryTableHeight() {
    const tableHeight = window.innerHeight - 85;
    $('.sotRequestGrid').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHistoryTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    this.setHistoryTableHeight();
    // Set Dynamic Height of Panels
  }

  // Get Order Details when opened in Edit/View Mode
  getRequestHistoryDetails() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.stockTransferService.getSotRequestHistory(this.sotRequestId).subscribe((result: any) => {
      this.requestHistoryDS = new MatTableDataSource(result.sotRequestCommentList);
      this.sotRequestNumber = result.sotRequestNumber;
      this.requestedBy = result.requestedBy;
      this.creationDate = result.creationDate;
      this.approvedBy = result.approvedBy;
      this.approvalDate = result.approvalDate;
      this.isFromAccess = result.isFromAccess;
      this.isToAccess = result.isToAccess;
      this.isrequestStatus = result.requestStatus == 'REJECTED' || result.requestStatus == 'SUBMITTED' ? true : false;
      this.loaderService.setLoaderStatus(false);
    },
      error => this.loaderService.setLoaderStatus(false)));
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
